import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('w-btn',{staticClass:"w-btn-small page-back-btn",class:{'page-back-btn-absolute': _vm.absolute_btn},attrs:{"color":"primary","text":"","data-test-id":"go-back-btn"},on:{"click":_vm.on_click}},[_c(VIcon,{attrs:{"size":"16"}},[_vm._v("$vuetify.icons.chevron_backward")]),_vm._v(_vm._s(_vm.l.t('app.back-lowercase', 'back'))+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }